<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Mot de passe oublié</div>
    </v-ons-toolbar>

    <div class="content">

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list modifier="noborder perflist">

        <app-label input-id="inputEmail" label="Votre email d'inscription sur Perfarmer" :error-msg-list="errorMsgList"></app-label>
        <app-input input-id="inputEmail" ref="inputEmail" input-type="email" v-model="email"
                   placeholder="Entrez votre email" @keyup-enter="resetPassword"></app-input>

        <template v-if="showPassword">
          <app-label input-id="inputPassword" label="Mot de passe" :error-msg-list="errorMsgList"></app-label>
          <app-input input-id="inputPassword" ref="inputPassword" input-type="password" v-model="password"
                    placeholder="Entrez votre mot de passe" @keyup-enter="resetPassword"></app-input>
        </template>

      </v-ons-list>

      <footer class="footer--perfbutton">
        <v-ons-button modifier="large--cta perflarge" @click="resetPassword" :disabled="! email">
          Recevoir un nouveau mot de passe
          <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
        </v-ons-button>
      </footer>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppLabel from '../partials/Label.vue';
import AppInput from '../partials/Input.vue';

export default {
  mixins: [mixinsCommons],
  components: { AppErrorMsg, AppLabel, AppInput },
  props: ['pageStack'],
  data() {
    return {
      email: '',
      showPassword: false,
      password: ''
    };
  },
  methods: {
    async resetPassword() {
      if(this.isSubmit || ! this.email){
        return;
      }
      if(this.showPassword && ! this.password){
        this.setErrorMsgList('inputPassword', "Le mot de passe est obligatoire");
      }
      this.isSubmit = true;

      var fd = new FormData();
      fd.append('email', this.email);
      if(this.showPassword){
        fd.append('password', this.password);
      }

      const fetchInit = this.$getFetchInit('POST', true);
      fetchInit.body = fd;
      const callPath = this.$apiDomain + '/password/reset';
      try {
        await this.handleRequest(callPath, fetchInit);

        this.pageStack.length > 1 && this.pageStack.pop();
        this.$showToast('Email envoyé');

      } catch(error) {
        this.handleError(error, 'de la mise à jour de votre mot de passe');
      }
    }
  }
};
</script>
